import { Component, OnInit, inject } from "@angular/core";
import { Observable } from "rxjs";
import {
  catchError,
  finalize,
  map,
  shareReplay,
  takeUntil,
  tap,
} from "rxjs/operators";

import { CustomResultOfListOfGetAllAggregatorsDto } from "src/app/core/api/models";
import { EventTypes } from "src/app/core/constants/event-types";
import { ConsoleService } from "src/app/core/services/console.service";
import { GetAllAggregatorsDto } from "../../../core/api/models/get-all-aggregators-dto";
import { GetEnumValuesDto } from "../../../core/api/models/get-enum-values-dto";
import { AggregatorsService } from "../../../core/api/services/aggregators.service";
import { AppDomService } from "../../../core/services/dom.service";
import { BaseIndexPageComponent } from "../../shared/base/components/base-index-page.component";
import { FormPageConfig } from "./../../../core/models/form-page-config.model";
import { AggregatorsFormComponent } from "./aggregators-form/aggregators-form.component";
import { NumberAggregatorComponent } from "./number-aggregator/number-aggregator.component";
import { UpdateRegexFormComponent } from "./update-regex-form/update-regex-form.component";
import { ValidateNumberComponent } from "./validate-number/validate-number.component";
import { PageNames } from "src/app/configs/page-names.enum";
import { BaseIndexModule } from "../../shared/base/modules/base-index.module";


@Component({
    selector: "app-aggregators",
    templateUrl: "./aggregators.component.html",
    imports: [BaseIndexModule]
}) 
export class AggregatorsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.aggregators;
  protected currentService = inject(AggregatorsService);
  createGetApiMethodName: string = this.currentService.aggregatorsCreateAggregatorGet.name;
  auditApiMethodName: string = this.currentService.aggregatorsGetAggregatorsAudit.name;

  modelWithPagination$: Observable<any>;
  items$: Observable<Array<GetAllAggregatorsDto>>;
  formPageConfig: FormPageConfig<GetAllAggregatorsDto> = {};
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      if (this.currentUserInfo.organizationId != 1)
        this.pageConfig.showAddBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi("SmsAggregator")
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorsEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}smsAggregator`,
        name: "id",
        type: "enum",
        enumName: "SmsAggregator",
        noSorting: true,
      },
      { title: this.localizer.name, name: "name", noSorting: true },
      { title: this.localizer.title, name: "title", noSorting: true },
      { title: `${this.tableVocabs}regex`, name: "regex", noSorting: true },
      {
        title: this.localizer.createDate,
        name: "created",
        type: "dateTime",
        noSorting: true,
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfListOfGetAllAggregatorsDto> {
    return this.currentService.aggregatorsGetAllAggregators();
  }

  getTableData() {
    try {
      this.pageConfig.loading = true;
      this.pageConfig.hasError = false;
      //گرفتن اطلاعات از سرور
      this.modelWithPagination$ = this.getPaginationApi().pipe(
        shareReplay(),
        catchError((error) => {
          this.pageConfig.isEmpty = false;
          this.pageConfig.hasError = true;
          return error;
        })
      );
      //مدلی که در ویو ساب اسکرایب میشه
      this.items$ = this.modelWithPagination$.pipe(
        tap((item) => {
          this.getPaginationData(item?.data);
        }),
        map((item) => item?.data),
        tap((items) => {
          items?.length > 0
            ? (this.pageConfig.isEmpty = false)
            : (this.pageConfig.isEmpty = true);
        }),
        takeUntil(this.onDestroy$),
        finalize(() => (this.pageConfig.loading = false))
      );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  //#region call Actions

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig.vocabs}addTitle`,
        isEdit: false,
      };

      const modalResult = this.dialogService.openModal({
        component: AggregatorsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  openEditFormModal(model: any) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}updateRegexTitle`,
        config: model,
        isEdit: true,
        id: model.id,
      };

      const modalResult = this.dialogService.openModal({
        component: UpdateRegexFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  onUpdateRegex(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;

    this.currentService
      .aggregatorsUpdateRegexGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(
        (Response) => {
          this.openEditFormModal(Response?.data);
        },
        (error) => ConsoleService.error("error", error),
        () => (this.pageConfig.loading = false)
      );
  }

  getNumberAggregator() {
    try {
      this.unSubs();

      let data = {
        title: `${this.pageVocabs}numberAggregator`,
        smsAggregatorsEnum: this.SmsAggregatorsEnumValues,
      };

      const modalResult = this.dialogService.openModal({
        component: NumberAggregatorComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //check is valid number
  getIsValidNumber() {
    try {
      this.unSubs();

      let data = {
        title: `${this.pageVocabs}isValidNumber`,
        smsAggregatorsEnum: this.SmsAggregatorsEnumValues,
      };

      const modalResult = this.dialogService.openModal({
        component: ValidateNumberComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
